import { render, staticRenderFns } from "./ProjectsIndex.vue?vue&type=template&id=c4e48a4a&scoped=true"
import script from "./ProjectsIndex.vue?vue&type=script&lang=js"
export * from "./ProjectsIndex.vue?vue&type=script&lang=js"
import style0 from "./ProjectsIndex.vue?vue&type=style&index=0&id=c4e48a4a&prod&scoped=true&lang=css"
import style1 from "./ProjectsIndex.vue?vue&type=style&index=1&id=c4e48a4a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4e48a4a",
  null
  
)

export default component.exports